import { render, staticRenderFns } from "./ModalIdentificacao.vue?vue&type=template&id=741de458&"
import script from "./ModalIdentificacao.vue?vue&type=script&lang=js&"
export * from "./ModalIdentificacao.vue?vue&type=script&lang=js&"
import style0 from "./ModalIdentificacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports